import {IMAGE_ASSET} from 'consts'

export function getDefaultAvatar() {
  return IMAGE_ASSET('giftshop', 'users/default-portrait.png')
}
